export default __webpack_public_path__ + "static/media/call.9af39362.svg";